import { render } from "./campaign.vue?vue&type=template&id=2dd988cd"
import script from "./campaign.vue?vue&type=script&lang=js"
export * from "./campaign.vue?vue&type=script&lang=js"

import "./campaign.vue?vue&type=style&index=0&id=2dd988cd&lang=css"

import exportComponent from "/Users/arthaskyline/Documents/FILE_DELFIN/kodingan-arthaskyline/level-up/levelup-github/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__